import { render } from "./MyHeader.vue?vue&type=template&id=20a51828&scoped=true"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"

import "./MyHeader.vue?vue&type=style&index=0&id=20a51828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a51828"]])

export default __exports__